<template>
  <div
    class="empty-placeholder dash-card bg-white"
    v-if="loading && !errorLoading"
  >
    <b-spinner></b-spinner>
  </div>
  <b-button variant="primary" @click="getInterests" v-else-if="errorLoading"
    >Network Error, Please Retry</b-button
  >
  <div
    v-else-if="interests.length < 1"
    class="empty-placeholder dash-card bg-white"
  >
    You have no interests yet
  </div>
  <b-row v-else>
    <b-col cols="12">
      <div class="list dash-card p-3 w-100 bg-white mb-2">
        <b-row>
          <b-col style="font-weight:bold">Farm</b-col>
          <b-col style="font-weight:bold">Month</b-col>
          <b-col style="font-weight:bold">Interest</b-col>
        </b-row>
      </div>
      <div
        class="list dash-card p-3 w-100 bg-white mb-2"
        v-for="(interest, index) in interests"
        :key="index"
        style="cursor:pointer"
      >
        <b-row>
          <b-col>{{ interest.farm }}</b-col>
          <b-col>{{ interest.month }}</b-col>
          <b-col>
            {{ formatMoney(interest.interest) }}
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { formatMoney } from "@/utils/helpers";
import { UserService } from "@/services";
export default {
  name: "investment-interests",
  data() {
    return {
      interests: [],
      total: 0,
      loading: false,
      errorLoading: false
    };
  },
  async created() {
    await this.getInterests();
  },
  methods: {
    formatMoney,
    async getInterests() {
      this.errorLoading = false;
      this.loading = true;
      try {
        const { data } = await UserService.getInvestments();
        
        let investments = data.investments.data;

        investments.forEach(inv => {

          inv.monthlygrowth.forEach(int => {

            this.interests.push({'month':int.month, 'interest':int.growth, 'farm':inv.package.packagename});
            this.total += Number(int.growth);

          })

        })

        this.$emit("total-interests", this.total);
        
      } catch (err) {
        this.errorLoading = true;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}
</style>
